import { render, staticRenderFns } from "./staffInfo.vue?vue&type=template&id=461611c6"
import script from "./staffInfo.vue?vue&type=script&lang=js"
export * from "./staffInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('461611c6')) {
      api.createRecord('461611c6', component.options)
    } else {
      api.reload('461611c6', component.options)
    }
    module.hot.accept("./staffInfo.vue?vue&type=template&id=461611c6", function () {
      api.rerender('461611c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesman/staffManage/staffInfo.vue"
export default component.exports